<template>
  <div
    class="container-fluid py-5 m-0"
    style="background-color: #2c2c2c !important; min-height: 100vh"
  >
    <div>
      <div class="d-flex gap-3 w-50 mx-auto">
        <RouterLink
          to="/"
          class="bg-secondary btn text-white rounded py-0 d-flex"
          style="height: 35px; align-items: center; justify-content: center"
        >
          Back
        </RouterLink>
        <div class="flex-grow-1">
          <input
            type="text"
            v-model="searchQuery"
            class="form-control invoice"
            style="background-color: #fff !important; color: #000 !important"
            placeholder="Search..."
          />
        </div>

        <div class="">
          <button
            @click="toggleModal"
            class="bg-success btn text-white rounded py-0"
            :style="{
              height: '35px',
            }"
          >
            Add New
          </button>
        </div>
      </div>
    </div>
    <div class="grid">
      <div v-for="server in servers" :key="server.id" class="server-card">
        <!-- Red Background Overlay if Latency Exceeds Limit -->
        <div
          v-if="Number(server.currentLatency) > Number(server.limit_ms)"
          class="overlay"
        ></div>

        <!-- Server Card -->
        <div class="card">
          <div class="card-top">
            <!-- Background Image -->
            <img
              src="@/assets/img/chartbg.png"
              alt="Background"
              class="bg-image"
            />

            <!-- Triangle Shape -->
            <div class="clip"></div>

            <!-- Latency Label -->
            <p style="color: #000 !important" class="latency-label">
              Latency (ms)
            </p>

            <!-- Chart -->
            <canvas
              :id="server.chartId"
              ref="chartCanvas"
              class="chart"
            ></canvas>

            <!-- Edit and Delete Icons -->
            <div class="icons">
              <i @click="editServer(server)" class="fas fa-edit edit-icon"></i>
              <i
                @click="deleteServer(server)"
                class="fas fa-trash trash-icon"
              ></i>
            </div>
          </div>

          <!-- Server Info -->
          <div class="card-info">
            <!-- Server Logo -->
            <div class="logo-container">
              <img
                v-if="server.logo"
                :src="server.logo"
                alt="Logo"
                class="logo"
              />
              <div v-else class="logo-placeholder"></div>
            </div>

            <!-- Server Name and Latency Badge -->
            <div class="server-details">
              <p style="color: #000 !important" class="server-name">
                {{ server.name }}
              </p>
              <span
                class="badge"
                style="color: #fff !important"
                :class="{
                  'badge-danger':
                    Number(server.currentLatency) > Number(server.limit_ms),
                  'badge-success':
                    Number(server.currentLatency) <= Number(server.limit_ms),
                }"
              >
                {{ server.currentLatency }} ms
              </span>
            </div>
            <p class="server-ip" style="color: #000 !important">
              {{ server.ip }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showModal" id="myModal" class="modal_class">
      <div class="modal-content dark-modeon">
        <span @click="toggleModal" class="close text-end">&times;</span>

        <div class="mb-4">
          <h5 class="mb-3">
            {{
              isEditing ? `Edit Server (ID: ${serverForm.id})` : "Add Server"
            }}
          </h5>

          <input
            type="text"
            placeholder="Server Name"
            class="form-control invoice-card mb-3"
            v-model="serverForm.ip_name"
            :disabled="loading"
          />
          <input
            type="text"
            placeholder="IP Address"
            class="form-control invoice-card mb-3"
            v-model="serverForm.ip"
            :disabled="loading"
          />
          <input
            type="number"
            placeholder="Latency Limit (ms)"
            class="form-control invoice-card mb-3"
            v-model="serverForm.limit_ms"
            :disabled="loading"
          />
          <div class="mb-3">
            <input
              type="file"
              class="form-control invoice-card"
              @change="handleLogoUpload"
              accept="image/*"
              ref="logoInput"
              :disabled="loading"
            />
          </div>
          <!-- Preview image if available and is a string (URL) -->
          <div
            v-if="serverForm.logo_ip && typeof serverForm.logo_ip === 'string'"
            class="mb-3"
          >
            <img
              :src="serverForm.logo_ip"
              alt="Logo preview"
              style="max-width: 100px; height: auto"
            />
          </div>
        </div>

        <div class="flex text-center">
          <!-- Original button with loading spinner -->
          <button
            class="bg-success btn text-white mx-3"
            @click="submitServer"
            :disabled="loading"
          >
            {{ isEditing ? "Update" : "Add New" }}
            <span
              v-if="loading"
              class="spinner-border spinner-border-sm mx-2"
            ></span>
          </button>
          <button class="btn btn-secondary mx-3" @click="toggleModal">
            Cancel
          </button>
        </div>
      </div>
    </div>

    <!-- Delete Confirmation Modal -->
    <div v-if="deleteConfirmation.show" id="myModal" class="modal_class">
      <div id="deleteModal" class="modal-content dark-modeon">
        <div class="d-flex justify-content-center align-items-center mb-3">
          <h5 class="text-center m-0">Are you sure?</h5>
        </div>
        <p class="text-center">Want to delete this server?</p>
        <span v-if="deleteConfirmation.loading">
          <Skalaton />
        </span>
        <p
          v-if="deleteConfirmation.error"
          class="text-center"
          style="color: red !important"
        >
          {{ deleteConfirmation.error }}
        </p>
        <div class="text-center">
          <button
            :disabled="deleteConfirmation.loading"
            @click="confirmDelete"
            class="btn btn-danger w-40 mx-1"
          >
            Yes, delete it!
          </button>
          <button class="btn btn-success w-40 mx-1" @click="cancelDelete">
            No, keep it
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, onUnmounted, reactive, ref, computed, watch } from "vue";
// import Chart from "chart.js/auto";
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);
import { usePingApi } from "@/services/ping.service";
import showSwal from "/src/mixins/showSwal.js";
import { RouterLink } from "vue-router";

export default {
  name: "LatencyChart",
  setup() {
    const servers = reactive([]);
    const chartInstances = {};
    let intervalIds = [];
    const searchQuery = ref("");
    const showModal = ref(false);
    const isEditing = ref(false);
    const loading = ref(false);
    const serverForm = reactive({
      id: "",
      ip_name: "",
      ip: "",
      limit_ms: "50",
      logo_ip: null,
    });

    const resetForm = () => {
      Object.assign(serverForm, {
        id: "",
        ip_name: "",
        ip: "",
        limit_ms: "50",
        logo_ip: null,
      });
      isEditing.value = false;
      if (logoInput.value) {
        logoInput.value.value = ""; // Reset file input
      }
    };

    const toggleModal = () => {
      showModal.value = !showModal.value;
      if (!showModal.value) {
        resetForm();
      }
    };

    const handleLogoUpload = (event) => {
      const file = event.target.files[0];
      if (!file) return;
      serverForm.logo_ip = file;
    };

    const editServer = (server) => {
      console.log("Server data received:", server);
      isEditing.value = true;
      serverForm.id = server.id || server._id;
      serverForm.ip_name = server.name;
      serverForm.ip = server.ip;
      serverForm.limit_ms = server.limit_ms?.toString() || "50";
      serverForm.logo_ip = server.logo_ip || null;
      console.log("Server form after edit:", serverForm);
      showModal.value = true;
    };

    const deleteConfirmation = reactive({
      show: false,
      loading: false,
      error: null,
      serverToDelete: null,
    });

    const deleteServer = (server) => {
      // Reset state when starting new delete operation
      Object.assign(deleteConfirmation, {
        show: true,
        loading: false,
        error: null,
        serverToDelete: server,
      });
    };

    const cancelDelete = () => {
      // Reset all state when canceling
      Object.assign(deleteConfirmation, {
        show: false,
        loading: false,
        error: null,
        serverToDelete: null,
      });
    };

    const confirmDelete = async () => {
      if (!deleteConfirmation.serverToDelete) return;

      // Set loading state atomically
      Object.assign(deleteConfirmation, {
        loading: true,
        error: null,
      });

      try {
        await usePingApi().deleteServer(deleteConfirmation.serverToDelete.id);
        await refetch();
        showSwal.methods.showSwal({
          type: "success",
          message: "Server deleted successfully!",
        });
        // Reset state on success
        Object.assign(deleteConfirmation, {
          show: false,
          loading: false,
          error: null,
          serverToDelete: null,
        });
      } catch (error) {
        console.error("Error deleting server:", error);
        // Update error state atomically
        Object.assign(deleteConfirmation, {
          loading: false,
          error:
            error.response?.data?.message ||
            "An error occurred while deleting the server.",
        });
      }
    };

    const refetch = async () => {
      // Clear all previous data
      servers.length = 0; // Clear servers array

      // Clear intervals
      intervalIds.forEach(clearInterval);
      intervalIds = [];

      // Clear and destroy charts
      Object.values(chartInstances).forEach((chart) => {
        if (chart) chart.destroy();
      });
      Object.keys(chartInstances).forEach((key) => delete chartInstances[key]);

      // Fetch new data
      await getData();
    };

    const setLoading = (value) => {
      loading.value = value;
    };

    const submitServer = async () => {
      if (loading.value) return; // Prevent multiple submissions

      setLoading(true);

      try {
        console.log("Current server form:", serverForm);

        const formData = new FormData();
        formData.append("ip_name", serverForm.ip_name);
        formData.append("ip", serverForm.ip);
        formData.append("limit_ms", serverForm.limit_ms);

        if (serverForm.logo_ip instanceof File) {
          formData.append("logo_ip", serverForm.logo_ip);
        }

        if (isEditing.value) {
          if (!serverForm.id) {
            throw new Error("Server ID is missing");
          }
          formData.append("id", serverForm.id);
          const response = await usePingApi().updateServer(
            serverForm.id,
            formData
          );
          console.log("Update response:", response);
          showSwal.methods.showSwal({
            type: "success",
            message: "Server updated successfully!",
          });
        } else {
          const response = await usePingApi().createServer(formData);
          console.log("Create response:", response);
          showSwal.methods.showSwal({
            type: "success",
            message: "Server created successfully!",
          });
        }

        await refetch();
        toggleModal();
        resetForm();
      } catch (error) {
        console.error("Error submitting server:", error);
        showSwal.methods.showSwal({
          type: "error",
          message:
            error.response?.data?.message ||
            "An error occurred. Please try again.",
        });
      } finally {
        setLoading(false);
      }
    };

    const filteredServers = computed(() => {
      const query = searchQuery.value.toLowerCase().trim();
      if (!query) return servers;

      return servers.filter(
        (server) =>
          server.name.toLowerCase().includes(query) ||
          server.ip.toLowerCase().includes(query)
      );
    });

    const createChart = (id) => {
      const canvas = document.getElementById(id);
      if (!canvas) return null;

      const ctx = canvas.getContext("2d");

      // Generate timestamps for the last 10 seconds
      const now = new Date();
      const labels = Array.from({ length: 10 }, (_, i) => {
        const time = new Date(now - (10 - i) * 1000); // Last 10 seconds
        return time.toLocaleTimeString(); // Format as HH:MM:SS
      });

      const dataPoints = Array(10).fill(0); // Initialize with 10 data points

      return new Chart(ctx, {
        type: "line",
        data: {
          labels: labels, // Use dynamic timestamps
          datasets: [
            {
              label: "Latency (ms)",
              data: dataPoints,
              borderColor: "white",
              borderWidth: 2,
              fill: false,
            },
          ],
        },
        options: {
          animation: {
            duration: 1000, // Animation duration in milliseconds
            easing: "easeOutQuart", // Smooth easing function
          },
          elements: {
            line: {
              tension: 0.4, // Add curve to the line
            },
          },
          scales: {
            x: {
              display: true,
              title: {
                display: true,
                text: "",
                color: "#fff",
                font: {
                  size: 14,
                },
              },
              ticks: {
                color: "black",
                autoSkip: false,
                maxRotation: 45,
                minRotation: 45,
              },
            },
            y: {
              suggestedMax: Math.max(...dataPoints) + 1,
              title: {
                display: false,
              },
              beginAtZero: false,
              ticks: {
                color: "black",
                stepSize: 1,
              },
              min: (ctx) => {
                const minValue = Math.min(...ctx.chart.data.datasets[0].data);
                return minValue - 1; // Minimum value is 1 less than the lowest ping
              },
              max: (ctx) => {
                const maxValue = Math.max(...ctx.chart.data.datasets[0].data);
                return maxValue + 1; // Maximum value is 1 more than the highest ping
              },
            },
          },
          plugins: {
            legend: { display: false },
            tooltip: {
              backgroundColor: "rgba(26, 32, 53, 0.9)",
              titleColor: "#344767",
              bodyColor: "#fff",
              borderColor: "#3498db",
              borderWidth: 1,
              padding: 10,
              displayColors: false,
              titleFont: {
                size: 14,
                weight: "bold",
              },
              bodyFont: {
                size: 13,
              },
              callbacks: {
                label: (context) => `Latency: ${context.raw} ms`,
              },
            },
          },
        },
      });
    };

    const updateChartData = async (server, chart) => {
      try {
        const response = await usePingApi().checkPing(server.ip);
        const newLatency = response.latency_ms;

        // Update chart data
        const newData = [...chart.data.datasets[0].data];
        newData.push(newLatency);
        if (newData.length > 10) {
          newData.shift();
        }

        // Update labels with current time
        const now = new Date();
        const newLabel = now.toLocaleTimeString(); // Format as HH:MM:SS
        const newLabels = [...chart.data.labels];
        newLabels.push(newLabel);
        if (newLabels.length > 10) {
          newLabels.shift();
        }

        // Update chart
        chart.data.labels = newLabels;
        chart.data.datasets[0].data = newData;
        chart.update();

        // Update server data atomically
        const serverIndex = servers.findIndex((s) => s.id === server.id);
        if (serverIndex !== -1) {
          servers[serverIndex] = {
            ...servers[serverIndex],
            currentLatency: newLatency,
          };
        }
      } catch (error) {
        console.error("Error updating chart data:", error);
      }
    };
    const getData = async () => {
      try {
        const { data } = await usePingApi().getPing();

        // Initialize servers with debug logging
        data.forEach((serverData) => {
          console.log("Server data from API:", serverData); // Debug log
          servers.push({
            id: serverData.id,
            chartId: `latencyChart${serverData.id}`,
            name: serverData.ip_name,
            ip: serverData.ip,
            logo: serverData.logo_ip,
            currentLatency: 0,
            limit_ms: serverData.limit_ms,
          });
        });

        // Create charts and start updates
        setTimeout(() => {
          servers.forEach((server) => {
            const chart = createChart(server.chartId);
            if (chart) {
              chartInstances[server.chartId] = chart;
              updateChartData(server, chart);

              const intervalId = setInterval(() => {
                updateChartData(server, chart);
              }, 1000);

              intervalIds.push(intervalId);
            }
          });
        }, 100);
      } catch (error) {
        console.error("Failed to initialize servers:", error);
      }
    };

    const logoInput = ref(null);

    onMounted(async () => {
      await getData();
    });

    onUnmounted(() => {
      intervalIds.forEach(clearInterval);
      Object.values(chartInstances).forEach((chart) => {
        if (chart) chart.destroy();
      });
    });

    // Add a watcher for debugging
    watch(
      () => serverForm.id,
      (newId) => {
        console.log("Server ID changed:", newId);
      }
    );

    return {
      servers: filteredServers,
      searchQuery,
      showModal,
      isEditing,
      serverForm,
      toggleModal,
      handleLogoUpload,
      submitServer,
      editServer,
      deleteServer,
      deleteConfirmation,
      cancelDelete,
      confirmDelete,
      logoInput,
      loading,
    };
  },
};
</script>
<style scoped>
/* Grid Layout */
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 18px;
  padding: 12px;
}

@media (max-width: 768px) {
  .grid {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
}

@media (max-width: 576px) {
  .grid {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }
}

/* Server Card */
.server-card {
  position: relative;
}

.card {
  border: 1px solid #ddd;
  border-radius: 12px;
  overflow: hidden;
  background-color: #fff;
}

.card-top {
  position: relative;
  height: 200px;
  padding: 12px;
}

.bg-image {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.clip {
  clip-path: polygon(0 71%, 0% 100%, 100% 100%);
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 180px;
  background: rgba(128, 128, 128, 0.164);
}

.latency-label {
  color: black;
  font-weight: 500;
  font-size: 14px;
  position: relative;
  z-index: 210;
  opacity: 0.8;
  text-align: center;
  margin: 0;
}

.chart {
  position: relative;
  z-index: 210;
}

.icons {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 211;
  display: flex;
  gap: 12px;
}

.edit-icon,
.trash-icon {
  font-size: 14px;
  cursor: pointer;
  transition: color 0.3s ease-in-out;
}

.edit-icon {
  color: rgba(0, 0, 255, 0.486);
}

.edit-icon:hover {
  color: blue;
}

.trash-icon {
  color: rgba(255, 0, 0, 0.534);
}

.trash-icon:hover {
  color: red;
}

/* Server Info */
.card-info {
  text-align: center;
  margin-top: -35px;
  position: relative;
  z-index: 1000;
}

.logo-container {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background-color: #dc3545;
  margin: 0 auto 8px;
}

.logo {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.logo-placeholder {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #dc3545;
}

.server-details {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.server-name {
  color: #000;
  font-size: 13px;
  font-weight: 600;
  margin: 0;
}

.badge {
  color: #fff;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 12px;
}

.badge-danger {
  background-color: #dc3545;
}

.badge-success {
  background-color: #28a745;
}

.server-ip {
  color: #000;
  font-size: 15px;
  opacity: 0.5;
  margin: 0;
}

/* Overlay for Exceeded Latency */
.overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, #ffebee 60%, #ffcdd2 100%);
  border-radius: 12px;
  z-index: 200;
}
</style>
